var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"series-item",on:{"click":function($event){return _vm.gotoProductDetail()}}},[_c('img',{attrs:{"src":_vm.info.imageUrl}}),_c('div',{staticClass:"tit"},[_vm._v(_vm._s(_vm.info.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }